var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { Component } from 'react';
var View = /** @class */ (function (_super) {
    __extends(View, _super);
    function View() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    View.prototype.render = function () {
        var _a = this.props, children = _a.children, style = _a.style, flex = _a.flex, allowWrap = _a.allowWrap, row = _a.row, left = _a.left, center = _a.center, right = _a.right, props = __rest(_a, ["children", "style", "flex", "allowWrap", "row", "left", "center", "right"]);
        var styles = {
            display: (typeof flex === 'boolean') ? 'flex' : undefined,
            flex: Number(flex) || undefined,
            flexDirection: row ? 'row' : (typeof flex === 'boolean') ? 'column' : undefined,
            justifyContent: left
                ? 'flex-start'
                : right ? 'flex-end' : center ? 'center' : undefined,
            alignItems: center ? 'center' : undefined,
            flexWrap: allowWrap ? 'wrap' : 'nowrap'
        };
        var estilos = __assign(__assign({}, styles), style);
        return (React.createElement("div", __assign({}, props, { style: estilos }), children));
    };
    return View;
}(Component));
export default View;



//////////////////
// WEBPACK FOOTER
// ./src/elements/View.tsx
// module id = 36
// module chunks = 0